module.exports = __webpack_public_path__ + "img/Cooler compressor.4f32f919.jpg";